/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkflowSettingsRouteImport } from './routes/workflow-settings'
import { Route as LoginRouteImport } from './routes/login'
import { Route as TenantAdminRouteRouteImport } from './routes/tenant-admin/route'
import { Route as ItServiceRouteRouteImport } from './routes/it-service/route'
import { Route as EntryRouteRouteImport } from './routes/entry/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TenantAdminIndexRouteImport } from './routes/tenant-admin/index'
import { Route as ItServiceIndexRouteImport } from './routes/it-service/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as TenantAdminOverviewRouteImport } from './routes/tenant-admin/overview'
import { Route as TenantAdminOrganizationRouteImport } from './routes/tenant-admin/organization'
import { Route as TenantAdminMonitoringRouteImport } from './routes/tenant-admin/monitoring'
import { Route as TenantAdminMenuManagementRouteImport } from './routes/tenant-admin/menu-management'
import { Route as TenantAdminMcpRouteImport } from './routes/tenant-admin/mcp'
import { Route as TenantAdminIntegrationsRouteImport } from './routes/tenant-admin/integrations'
import { Route as TenantAdminIdentityRouteImport } from './routes/tenant-admin/identity'
import { Route as TenantAdminAuthenticationRouteImport } from './routes/tenant-admin/authentication'
import { Route as TenantAdminAccessControlRouteImport } from './routes/tenant-admin/access-control'
import { Route as ItServiceMyTicketsRouteImport } from './routes/it-service/my-tickets'
import { Route as AdminWorkflowSettingsRouteImport } from './routes/admin/workflow-settings'
import { Route as AdminTenantsRouteImport } from './routes/admin/tenants'
import { Route as AdminServiceRouteImport } from './routes/admin/service'
import { Route as AdminPortalServiceRouteImport } from './routes/admin/portal-service'
import { Route as AdminOperatorRouteImport } from './routes/admin/operator'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminItopsAgentRouteImport } from './routes/admin/itops-agent'
import { Route as AdminDataStorageRouteImport } from './routes/admin/data-storage'
import { Route as ItServiceServicerequestsIndexRouteImport } from './routes/it-service/servicerequests/index'
import { Route as ItServiceIncidentsIndexRouteImport } from './routes/it-service/incidents/index'
import { Route as ItServiceChangerequestsIndexRouteImport } from './routes/it-service/changerequests/index'
import { Route as AdminMcpIndexRouteImport } from './routes/admin/mcp/index'
import { Route as McpOauthCallbackRouteImport } from './routes/mcp/oauth/callback'
import { Route as ItServiceTicketsTicketIdRouteImport } from './routes/it-service/tickets/$ticketId'
import { Route as ItServiceServicerequestsNewRouteImport } from './routes/it-service/servicerequests/new'
import { Route as ItServiceIncidentsNewRouteImport } from './routes/it-service/incidents/new'
import { Route as ItServiceChangerequestsNewRouteImport } from './routes/it-service/changerequests/new'
import { Route as AdminMcpTenantsRouteImport } from './routes/admin/mcp/tenants'
import { Route as AdminMcpOauthRouteImport } from './routes/admin/mcp/oauth'
import { Route as AdminMcpLimitsRouteImport } from './routes/admin/mcp/limits'
import { Route as AdminItopsAgentCallbackRouteImport } from './routes/admin/itops-agent/callback'
import { Route as AdminItopsAgentAgentIdRouteImport } from './routes/admin/itops-agent/$agentId'

const WorkflowSettingsRoute = WorkflowSettingsRouteImport.update({
  id: '/workflow-settings',
  path: '/workflow-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantAdminRouteRoute = TenantAdminRouteRouteImport.update({
  id: '/tenant-admin',
  path: '/tenant-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ItServiceRouteRoute = ItServiceRouteRouteImport.update({
  id: '/it-service',
  path: '/it-service',
  getParentRoute: () => rootRouteImport,
} as any)
const EntryRouteRoute = EntryRouteRouteImport.update({
  id: '/entry',
  path: '/entry',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantAdminIndexRoute = TenantAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TenantAdminRouteRoute,
} as any)
const ItServiceIndexRoute = ItServiceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ItServiceRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TenantAdminOverviewRoute = TenantAdminOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => TenantAdminRouteRoute,
} as any)
const TenantAdminOrganizationRoute = TenantAdminOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => TenantAdminRouteRoute,
} as any)
const TenantAdminMonitoringRoute = TenantAdminMonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => TenantAdminRouteRoute,
} as any)
const TenantAdminMenuManagementRoute =
  TenantAdminMenuManagementRouteImport.update({
    id: '/menu-management',
    path: '/menu-management',
    getParentRoute: () => TenantAdminRouteRoute,
  } as any)
const TenantAdminMcpRoute = TenantAdminMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => TenantAdminRouteRoute,
} as any)
const TenantAdminIntegrationsRoute = TenantAdminIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => TenantAdminRouteRoute,
} as any)
const TenantAdminIdentityRoute = TenantAdminIdentityRouteImport.update({
  id: '/identity',
  path: '/identity',
  getParentRoute: () => TenantAdminRouteRoute,
} as any)
const TenantAdminAuthenticationRoute =
  TenantAdminAuthenticationRouteImport.update({
    id: '/authentication',
    path: '/authentication',
    getParentRoute: () => TenantAdminRouteRoute,
  } as any)
const TenantAdminAccessControlRoute =
  TenantAdminAccessControlRouteImport.update({
    id: '/access-control',
    path: '/access-control',
    getParentRoute: () => TenantAdminRouteRoute,
  } as any)
const ItServiceMyTicketsRoute = ItServiceMyTicketsRouteImport.update({
  id: '/my-tickets',
  path: '/my-tickets',
  getParentRoute: () => ItServiceRouteRoute,
} as any)
const AdminWorkflowSettingsRoute = AdminWorkflowSettingsRouteImport.update({
  id: '/workflow-settings',
  path: '/workflow-settings',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTenantsRoute = AdminTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminServiceRoute = AdminServiceRouteImport.update({
  id: '/service',
  path: '/service',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPortalServiceRoute = AdminPortalServiceRouteImport.update({
  id: '/portal-service',
  path: '/portal-service',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOperatorRoute = AdminOperatorRouteImport.update({
  id: '/operator',
  path: '/operator',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminItopsAgentRoute = AdminItopsAgentRouteImport.update({
  id: '/itops-agent',
  path: '/itops-agent',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDataStorageRoute = AdminDataStorageRouteImport.update({
  id: '/data-storage',
  path: '/data-storage',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ItServiceServicerequestsIndexRoute =
  ItServiceServicerequestsIndexRouteImport.update({
    id: '/servicerequests/',
    path: '/servicerequests/',
    getParentRoute: () => ItServiceRouteRoute,
  } as any)
const ItServiceIncidentsIndexRoute = ItServiceIncidentsIndexRouteImport.update({
  id: '/incidents/',
  path: '/incidents/',
  getParentRoute: () => ItServiceRouteRoute,
} as any)
const ItServiceChangerequestsIndexRoute =
  ItServiceChangerequestsIndexRouteImport.update({
    id: '/changerequests/',
    path: '/changerequests/',
    getParentRoute: () => ItServiceRouteRoute,
  } as any)
const AdminMcpIndexRoute = AdminMcpIndexRouteImport.update({
  id: '/mcp/',
  path: '/mcp/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const McpOauthCallbackRoute = McpOauthCallbackRouteImport.update({
  id: '/mcp/oauth/callback',
  path: '/mcp/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ItServiceTicketsTicketIdRoute =
  ItServiceTicketsTicketIdRouteImport.update({
    id: '/tickets/$ticketId',
    path: '/tickets/$ticketId',
    getParentRoute: () => ItServiceRouteRoute,
  } as any)
const ItServiceServicerequestsNewRoute =
  ItServiceServicerequestsNewRouteImport.update({
    id: '/servicerequests/new',
    path: '/servicerequests/new',
    getParentRoute: () => ItServiceRouteRoute,
  } as any)
const ItServiceIncidentsNewRoute = ItServiceIncidentsNewRouteImport.update({
  id: '/incidents/new',
  path: '/incidents/new',
  getParentRoute: () => ItServiceRouteRoute,
} as any)
const ItServiceChangerequestsNewRoute =
  ItServiceChangerequestsNewRouteImport.update({
    id: '/changerequests/new',
    path: '/changerequests/new',
    getParentRoute: () => ItServiceRouteRoute,
  } as any)
const AdminMcpTenantsRoute = AdminMcpTenantsRouteImport.update({
  id: '/mcp/tenants',
  path: '/mcp/tenants',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMcpOauthRoute = AdminMcpOauthRouteImport.update({
  id: '/mcp/oauth',
  path: '/mcp/oauth',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMcpLimitsRoute = AdminMcpLimitsRouteImport.update({
  id: '/mcp/limits',
  path: '/mcp/limits',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminItopsAgentCallbackRoute = AdminItopsAgentCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AdminItopsAgentRoute,
} as any)
const AdminItopsAgentAgentIdRoute = AdminItopsAgentAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AdminItopsAgentRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/entry': typeof EntryRouteRoute
  '/it-service': typeof ItServiceRouteRouteWithChildren
  '/tenant-admin': typeof TenantAdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/workflow-settings': typeof WorkflowSettingsRoute
  '/admin/data-storage': typeof AdminDataStorageRoute
  '/admin/itops-agent': typeof AdminItopsAgentRouteWithChildren
  '/admin/login': typeof AdminLoginRoute
  '/admin/operator': typeof AdminOperatorRoute
  '/admin/portal-service': typeof AdminPortalServiceRoute
  '/admin/service': typeof AdminServiceRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/workflow-settings': typeof AdminWorkflowSettingsRoute
  '/it-service/my-tickets': typeof ItServiceMyTicketsRoute
  '/tenant-admin/access-control': typeof TenantAdminAccessControlRoute
  '/tenant-admin/authentication': typeof TenantAdminAuthenticationRoute
  '/tenant-admin/identity': typeof TenantAdminIdentityRoute
  '/tenant-admin/integrations': typeof TenantAdminIntegrationsRoute
  '/tenant-admin/mcp': typeof TenantAdminMcpRoute
  '/tenant-admin/menu-management': typeof TenantAdminMenuManagementRoute
  '/tenant-admin/monitoring': typeof TenantAdminMonitoringRoute
  '/tenant-admin/organization': typeof TenantAdminOrganizationRoute
  '/tenant-admin/overview': typeof TenantAdminOverviewRoute
  '/admin/': typeof AdminIndexRoute
  '/it-service/': typeof ItServiceIndexRoute
  '/tenant-admin/': typeof TenantAdminIndexRoute
  '/admin/itops-agent/$agentId': typeof AdminItopsAgentAgentIdRoute
  '/admin/itops-agent/callback': typeof AdminItopsAgentCallbackRoute
  '/admin/mcp/limits': typeof AdminMcpLimitsRoute
  '/admin/mcp/oauth': typeof AdminMcpOauthRoute
  '/admin/mcp/tenants': typeof AdminMcpTenantsRoute
  '/it-service/changerequests/new': typeof ItServiceChangerequestsNewRoute
  '/it-service/incidents/new': typeof ItServiceIncidentsNewRoute
  '/it-service/servicerequests/new': typeof ItServiceServicerequestsNewRoute
  '/it-service/tickets/$ticketId': typeof ItServiceTicketsTicketIdRoute
  '/mcp/oauth/callback': typeof McpOauthCallbackRoute
  '/admin/mcp/': typeof AdminMcpIndexRoute
  '/it-service/changerequests/': typeof ItServiceChangerequestsIndexRoute
  '/it-service/incidents/': typeof ItServiceIncidentsIndexRoute
  '/it-service/servicerequests/': typeof ItServiceServicerequestsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/entry': typeof EntryRouteRoute
  '/login': typeof LoginRoute
  '/workflow-settings': typeof WorkflowSettingsRoute
  '/admin/data-storage': typeof AdminDataStorageRoute
  '/admin/itops-agent': typeof AdminItopsAgentRouteWithChildren
  '/admin/login': typeof AdminLoginRoute
  '/admin/operator': typeof AdminOperatorRoute
  '/admin/portal-service': typeof AdminPortalServiceRoute
  '/admin/service': typeof AdminServiceRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/workflow-settings': typeof AdminWorkflowSettingsRoute
  '/it-service/my-tickets': typeof ItServiceMyTicketsRoute
  '/tenant-admin/access-control': typeof TenantAdminAccessControlRoute
  '/tenant-admin/authentication': typeof TenantAdminAuthenticationRoute
  '/tenant-admin/identity': typeof TenantAdminIdentityRoute
  '/tenant-admin/integrations': typeof TenantAdminIntegrationsRoute
  '/tenant-admin/mcp': typeof TenantAdminMcpRoute
  '/tenant-admin/menu-management': typeof TenantAdminMenuManagementRoute
  '/tenant-admin/monitoring': typeof TenantAdminMonitoringRoute
  '/tenant-admin/organization': typeof TenantAdminOrganizationRoute
  '/tenant-admin/overview': typeof TenantAdminOverviewRoute
  '/admin': typeof AdminIndexRoute
  '/it-service': typeof ItServiceIndexRoute
  '/tenant-admin': typeof TenantAdminIndexRoute
  '/admin/itops-agent/$agentId': typeof AdminItopsAgentAgentIdRoute
  '/admin/itops-agent/callback': typeof AdminItopsAgentCallbackRoute
  '/admin/mcp/limits': typeof AdminMcpLimitsRoute
  '/admin/mcp/oauth': typeof AdminMcpOauthRoute
  '/admin/mcp/tenants': typeof AdminMcpTenantsRoute
  '/it-service/changerequests/new': typeof ItServiceChangerequestsNewRoute
  '/it-service/incidents/new': typeof ItServiceIncidentsNewRoute
  '/it-service/servicerequests/new': typeof ItServiceServicerequestsNewRoute
  '/it-service/tickets/$ticketId': typeof ItServiceTicketsTicketIdRoute
  '/mcp/oauth/callback': typeof McpOauthCallbackRoute
  '/admin/mcp': typeof AdminMcpIndexRoute
  '/it-service/changerequests': typeof ItServiceChangerequestsIndexRoute
  '/it-service/incidents': typeof ItServiceIncidentsIndexRoute
  '/it-service/servicerequests': typeof ItServiceServicerequestsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/entry': typeof EntryRouteRoute
  '/it-service': typeof ItServiceRouteRouteWithChildren
  '/tenant-admin': typeof TenantAdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/workflow-settings': typeof WorkflowSettingsRoute
  '/admin/data-storage': typeof AdminDataStorageRoute
  '/admin/itops-agent': typeof AdminItopsAgentRouteWithChildren
  '/admin/login': typeof AdminLoginRoute
  '/admin/operator': typeof AdminOperatorRoute
  '/admin/portal-service': typeof AdminPortalServiceRoute
  '/admin/service': typeof AdminServiceRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/workflow-settings': typeof AdminWorkflowSettingsRoute
  '/it-service/my-tickets': typeof ItServiceMyTicketsRoute
  '/tenant-admin/access-control': typeof TenantAdminAccessControlRoute
  '/tenant-admin/authentication': typeof TenantAdminAuthenticationRoute
  '/tenant-admin/identity': typeof TenantAdminIdentityRoute
  '/tenant-admin/integrations': typeof TenantAdminIntegrationsRoute
  '/tenant-admin/mcp': typeof TenantAdminMcpRoute
  '/tenant-admin/menu-management': typeof TenantAdminMenuManagementRoute
  '/tenant-admin/monitoring': typeof TenantAdminMonitoringRoute
  '/tenant-admin/organization': typeof TenantAdminOrganizationRoute
  '/tenant-admin/overview': typeof TenantAdminOverviewRoute
  '/admin/': typeof AdminIndexRoute
  '/it-service/': typeof ItServiceIndexRoute
  '/tenant-admin/': typeof TenantAdminIndexRoute
  '/admin/itops-agent/$agentId': typeof AdminItopsAgentAgentIdRoute
  '/admin/itops-agent/callback': typeof AdminItopsAgentCallbackRoute
  '/admin/mcp/limits': typeof AdminMcpLimitsRoute
  '/admin/mcp/oauth': typeof AdminMcpOauthRoute
  '/admin/mcp/tenants': typeof AdminMcpTenantsRoute
  '/it-service/changerequests/new': typeof ItServiceChangerequestsNewRoute
  '/it-service/incidents/new': typeof ItServiceIncidentsNewRoute
  '/it-service/servicerequests/new': typeof ItServiceServicerequestsNewRoute
  '/it-service/tickets/$ticketId': typeof ItServiceTicketsTicketIdRoute
  '/mcp/oauth/callback': typeof McpOauthCallbackRoute
  '/admin/mcp/': typeof AdminMcpIndexRoute
  '/it-service/changerequests/': typeof ItServiceChangerequestsIndexRoute
  '/it-service/incidents/': typeof ItServiceIncidentsIndexRoute
  '/it-service/servicerequests/': typeof ItServiceServicerequestsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/entry'
    | '/it-service'
    | '/tenant-admin'
    | '/login'
    | '/workflow-settings'
    | '/admin/data-storage'
    | '/admin/itops-agent'
    | '/admin/login'
    | '/admin/operator'
    | '/admin/portal-service'
    | '/admin/service'
    | '/admin/tenants'
    | '/admin/workflow-settings'
    | '/it-service/my-tickets'
    | '/tenant-admin/access-control'
    | '/tenant-admin/authentication'
    | '/tenant-admin/identity'
    | '/tenant-admin/integrations'
    | '/tenant-admin/mcp'
    | '/tenant-admin/menu-management'
    | '/tenant-admin/monitoring'
    | '/tenant-admin/organization'
    | '/tenant-admin/overview'
    | '/admin/'
    | '/it-service/'
    | '/tenant-admin/'
    | '/admin/itops-agent/$agentId'
    | '/admin/itops-agent/callback'
    | '/admin/mcp/limits'
    | '/admin/mcp/oauth'
    | '/admin/mcp/tenants'
    | '/it-service/changerequests/new'
    | '/it-service/incidents/new'
    | '/it-service/servicerequests/new'
    | '/it-service/tickets/$ticketId'
    | '/mcp/oauth/callback'
    | '/admin/mcp/'
    | '/it-service/changerequests/'
    | '/it-service/incidents/'
    | '/it-service/servicerequests/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/entry'
    | '/login'
    | '/workflow-settings'
    | '/admin/data-storage'
    | '/admin/itops-agent'
    | '/admin/login'
    | '/admin/operator'
    | '/admin/portal-service'
    | '/admin/service'
    | '/admin/tenants'
    | '/admin/workflow-settings'
    | '/it-service/my-tickets'
    | '/tenant-admin/access-control'
    | '/tenant-admin/authentication'
    | '/tenant-admin/identity'
    | '/tenant-admin/integrations'
    | '/tenant-admin/mcp'
    | '/tenant-admin/menu-management'
    | '/tenant-admin/monitoring'
    | '/tenant-admin/organization'
    | '/tenant-admin/overview'
    | '/admin'
    | '/it-service'
    | '/tenant-admin'
    | '/admin/itops-agent/$agentId'
    | '/admin/itops-agent/callback'
    | '/admin/mcp/limits'
    | '/admin/mcp/oauth'
    | '/admin/mcp/tenants'
    | '/it-service/changerequests/new'
    | '/it-service/incidents/new'
    | '/it-service/servicerequests/new'
    | '/it-service/tickets/$ticketId'
    | '/mcp/oauth/callback'
    | '/admin/mcp'
    | '/it-service/changerequests'
    | '/it-service/incidents'
    | '/it-service/servicerequests'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/entry'
    | '/it-service'
    | '/tenant-admin'
    | '/login'
    | '/workflow-settings'
    | '/admin/data-storage'
    | '/admin/itops-agent'
    | '/admin/login'
    | '/admin/operator'
    | '/admin/portal-service'
    | '/admin/service'
    | '/admin/tenants'
    | '/admin/workflow-settings'
    | '/it-service/my-tickets'
    | '/tenant-admin/access-control'
    | '/tenant-admin/authentication'
    | '/tenant-admin/identity'
    | '/tenant-admin/integrations'
    | '/tenant-admin/mcp'
    | '/tenant-admin/menu-management'
    | '/tenant-admin/monitoring'
    | '/tenant-admin/organization'
    | '/tenant-admin/overview'
    | '/admin/'
    | '/it-service/'
    | '/tenant-admin/'
    | '/admin/itops-agent/$agentId'
    | '/admin/itops-agent/callback'
    | '/admin/mcp/limits'
    | '/admin/mcp/oauth'
    | '/admin/mcp/tenants'
    | '/it-service/changerequests/new'
    | '/it-service/incidents/new'
    | '/it-service/servicerequests/new'
    | '/it-service/tickets/$ticketId'
    | '/mcp/oauth/callback'
    | '/admin/mcp/'
    | '/it-service/changerequests/'
    | '/it-service/incidents/'
    | '/it-service/servicerequests/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  EntryRouteRoute: typeof EntryRouteRoute
  ItServiceRouteRoute: typeof ItServiceRouteRouteWithChildren
  TenantAdminRouteRoute: typeof TenantAdminRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  WorkflowSettingsRoute: typeof WorkflowSettingsRoute
  McpOauthCallbackRoute: typeof McpOauthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workflow-settings': {
      id: '/workflow-settings'
      path: '/workflow-settings'
      fullPath: '/workflow-settings'
      preLoaderRoute: typeof WorkflowSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenant-admin': {
      id: '/tenant-admin'
      path: '/tenant-admin'
      fullPath: '/tenant-admin'
      preLoaderRoute: typeof TenantAdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/it-service': {
      id: '/it-service'
      path: '/it-service'
      fullPath: '/it-service'
      preLoaderRoute: typeof ItServiceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entry': {
      id: '/entry'
      path: '/entry'
      fullPath: '/entry'
      preLoaderRoute: typeof EntryRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenant-admin/': {
      id: '/tenant-admin/'
      path: '/'
      fullPath: '/tenant-admin/'
      preLoaderRoute: typeof TenantAdminIndexRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/it-service/': {
      id: '/it-service/'
      path: '/'
      fullPath: '/it-service/'
      preLoaderRoute: typeof ItServiceIndexRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/tenant-admin/overview': {
      id: '/tenant-admin/overview'
      path: '/overview'
      fullPath: '/tenant-admin/overview'
      preLoaderRoute: typeof TenantAdminOverviewRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/tenant-admin/organization': {
      id: '/tenant-admin/organization'
      path: '/organization'
      fullPath: '/tenant-admin/organization'
      preLoaderRoute: typeof TenantAdminOrganizationRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/tenant-admin/monitoring': {
      id: '/tenant-admin/monitoring'
      path: '/monitoring'
      fullPath: '/tenant-admin/monitoring'
      preLoaderRoute: typeof TenantAdminMonitoringRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/tenant-admin/menu-management': {
      id: '/tenant-admin/menu-management'
      path: '/menu-management'
      fullPath: '/tenant-admin/menu-management'
      preLoaderRoute: typeof TenantAdminMenuManagementRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/tenant-admin/mcp': {
      id: '/tenant-admin/mcp'
      path: '/mcp'
      fullPath: '/tenant-admin/mcp'
      preLoaderRoute: typeof TenantAdminMcpRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/tenant-admin/integrations': {
      id: '/tenant-admin/integrations'
      path: '/integrations'
      fullPath: '/tenant-admin/integrations'
      preLoaderRoute: typeof TenantAdminIntegrationsRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/tenant-admin/identity': {
      id: '/tenant-admin/identity'
      path: '/identity'
      fullPath: '/tenant-admin/identity'
      preLoaderRoute: typeof TenantAdminIdentityRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/tenant-admin/authentication': {
      id: '/tenant-admin/authentication'
      path: '/authentication'
      fullPath: '/tenant-admin/authentication'
      preLoaderRoute: typeof TenantAdminAuthenticationRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/tenant-admin/access-control': {
      id: '/tenant-admin/access-control'
      path: '/access-control'
      fullPath: '/tenant-admin/access-control'
      preLoaderRoute: typeof TenantAdminAccessControlRouteImport
      parentRoute: typeof TenantAdminRouteRoute
    }
    '/it-service/my-tickets': {
      id: '/it-service/my-tickets'
      path: '/my-tickets'
      fullPath: '/it-service/my-tickets'
      preLoaderRoute: typeof ItServiceMyTicketsRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/admin/workflow-settings': {
      id: '/admin/workflow-settings'
      path: '/workflow-settings'
      fullPath: '/admin/workflow-settings'
      preLoaderRoute: typeof AdminWorkflowSettingsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tenants': {
      id: '/admin/tenants'
      path: '/tenants'
      fullPath: '/admin/tenants'
      preLoaderRoute: typeof AdminTenantsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/service': {
      id: '/admin/service'
      path: '/service'
      fullPath: '/admin/service'
      preLoaderRoute: typeof AdminServiceRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/portal-service': {
      id: '/admin/portal-service'
      path: '/portal-service'
      fullPath: '/admin/portal-service'
      preLoaderRoute: typeof AdminPortalServiceRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/operator': {
      id: '/admin/operator'
      path: '/operator'
      fullPath: '/admin/operator'
      preLoaderRoute: typeof AdminOperatorRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/itops-agent': {
      id: '/admin/itops-agent'
      path: '/itops-agent'
      fullPath: '/admin/itops-agent'
      preLoaderRoute: typeof AdminItopsAgentRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/data-storage': {
      id: '/admin/data-storage'
      path: '/data-storage'
      fullPath: '/admin/data-storage'
      preLoaderRoute: typeof AdminDataStorageRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/it-service/servicerequests/': {
      id: '/it-service/servicerequests/'
      path: '/servicerequests'
      fullPath: '/it-service/servicerequests/'
      preLoaderRoute: typeof ItServiceServicerequestsIndexRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/it-service/incidents/': {
      id: '/it-service/incidents/'
      path: '/incidents'
      fullPath: '/it-service/incidents/'
      preLoaderRoute: typeof ItServiceIncidentsIndexRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/it-service/changerequests/': {
      id: '/it-service/changerequests/'
      path: '/changerequests'
      fullPath: '/it-service/changerequests/'
      preLoaderRoute: typeof ItServiceChangerequestsIndexRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/admin/mcp/': {
      id: '/admin/mcp/'
      path: '/mcp'
      fullPath: '/admin/mcp/'
      preLoaderRoute: typeof AdminMcpIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/mcp/oauth/callback': {
      id: '/mcp/oauth/callback'
      path: '/mcp/oauth/callback'
      fullPath: '/mcp/oauth/callback'
      preLoaderRoute: typeof McpOauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/it-service/tickets/$ticketId': {
      id: '/it-service/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/it-service/tickets/$ticketId'
      preLoaderRoute: typeof ItServiceTicketsTicketIdRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/it-service/servicerequests/new': {
      id: '/it-service/servicerequests/new'
      path: '/servicerequests/new'
      fullPath: '/it-service/servicerequests/new'
      preLoaderRoute: typeof ItServiceServicerequestsNewRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/it-service/incidents/new': {
      id: '/it-service/incidents/new'
      path: '/incidents/new'
      fullPath: '/it-service/incidents/new'
      preLoaderRoute: typeof ItServiceIncidentsNewRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/it-service/changerequests/new': {
      id: '/it-service/changerequests/new'
      path: '/changerequests/new'
      fullPath: '/it-service/changerequests/new'
      preLoaderRoute: typeof ItServiceChangerequestsNewRouteImport
      parentRoute: typeof ItServiceRouteRoute
    }
    '/admin/mcp/tenants': {
      id: '/admin/mcp/tenants'
      path: '/mcp/tenants'
      fullPath: '/admin/mcp/tenants'
      preLoaderRoute: typeof AdminMcpTenantsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/mcp/oauth': {
      id: '/admin/mcp/oauth'
      path: '/mcp/oauth'
      fullPath: '/admin/mcp/oauth'
      preLoaderRoute: typeof AdminMcpOauthRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/mcp/limits': {
      id: '/admin/mcp/limits'
      path: '/mcp/limits'
      fullPath: '/admin/mcp/limits'
      preLoaderRoute: typeof AdminMcpLimitsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/itops-agent/callback': {
      id: '/admin/itops-agent/callback'
      path: '/callback'
      fullPath: '/admin/itops-agent/callback'
      preLoaderRoute: typeof AdminItopsAgentCallbackRouteImport
      parentRoute: typeof AdminItopsAgentRoute
    }
    '/admin/itops-agent/$agentId': {
      id: '/admin/itops-agent/$agentId'
      path: '/$agentId'
      fullPath: '/admin/itops-agent/$agentId'
      preLoaderRoute: typeof AdminItopsAgentAgentIdRouteImport
      parentRoute: typeof AdminItopsAgentRoute
    }
  }
}

interface AdminItopsAgentRouteChildren {
  AdminItopsAgentAgentIdRoute: typeof AdminItopsAgentAgentIdRoute
  AdminItopsAgentCallbackRoute: typeof AdminItopsAgentCallbackRoute
}

const AdminItopsAgentRouteChildren: AdminItopsAgentRouteChildren = {
  AdminItopsAgentAgentIdRoute: AdminItopsAgentAgentIdRoute,
  AdminItopsAgentCallbackRoute: AdminItopsAgentCallbackRoute,
}

const AdminItopsAgentRouteWithChildren = AdminItopsAgentRoute._addFileChildren(
  AdminItopsAgentRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminDataStorageRoute: typeof AdminDataStorageRoute
  AdminItopsAgentRoute: typeof AdminItopsAgentRouteWithChildren
  AdminLoginRoute: typeof AdminLoginRoute
  AdminOperatorRoute: typeof AdminOperatorRoute
  AdminPortalServiceRoute: typeof AdminPortalServiceRoute
  AdminServiceRoute: typeof AdminServiceRoute
  AdminTenantsRoute: typeof AdminTenantsRoute
  AdminWorkflowSettingsRoute: typeof AdminWorkflowSettingsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminMcpLimitsRoute: typeof AdminMcpLimitsRoute
  AdminMcpOauthRoute: typeof AdminMcpOauthRoute
  AdminMcpTenantsRoute: typeof AdminMcpTenantsRoute
  AdminMcpIndexRoute: typeof AdminMcpIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminDataStorageRoute: AdminDataStorageRoute,
  AdminItopsAgentRoute: AdminItopsAgentRouteWithChildren,
  AdminLoginRoute: AdminLoginRoute,
  AdminOperatorRoute: AdminOperatorRoute,
  AdminPortalServiceRoute: AdminPortalServiceRoute,
  AdminServiceRoute: AdminServiceRoute,
  AdminTenantsRoute: AdminTenantsRoute,
  AdminWorkflowSettingsRoute: AdminWorkflowSettingsRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminMcpLimitsRoute: AdminMcpLimitsRoute,
  AdminMcpOauthRoute: AdminMcpOauthRoute,
  AdminMcpTenantsRoute: AdminMcpTenantsRoute,
  AdminMcpIndexRoute: AdminMcpIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface ItServiceRouteRouteChildren {
  ItServiceMyTicketsRoute: typeof ItServiceMyTicketsRoute
  ItServiceIndexRoute: typeof ItServiceIndexRoute
  ItServiceChangerequestsNewRoute: typeof ItServiceChangerequestsNewRoute
  ItServiceIncidentsNewRoute: typeof ItServiceIncidentsNewRoute
  ItServiceServicerequestsNewRoute: typeof ItServiceServicerequestsNewRoute
  ItServiceTicketsTicketIdRoute: typeof ItServiceTicketsTicketIdRoute
  ItServiceChangerequestsIndexRoute: typeof ItServiceChangerequestsIndexRoute
  ItServiceIncidentsIndexRoute: typeof ItServiceIncidentsIndexRoute
  ItServiceServicerequestsIndexRoute: typeof ItServiceServicerequestsIndexRoute
}

const ItServiceRouteRouteChildren: ItServiceRouteRouteChildren = {
  ItServiceMyTicketsRoute: ItServiceMyTicketsRoute,
  ItServiceIndexRoute: ItServiceIndexRoute,
  ItServiceChangerequestsNewRoute: ItServiceChangerequestsNewRoute,
  ItServiceIncidentsNewRoute: ItServiceIncidentsNewRoute,
  ItServiceServicerequestsNewRoute: ItServiceServicerequestsNewRoute,
  ItServiceTicketsTicketIdRoute: ItServiceTicketsTicketIdRoute,
  ItServiceChangerequestsIndexRoute: ItServiceChangerequestsIndexRoute,
  ItServiceIncidentsIndexRoute: ItServiceIncidentsIndexRoute,
  ItServiceServicerequestsIndexRoute: ItServiceServicerequestsIndexRoute,
}

const ItServiceRouteRouteWithChildren = ItServiceRouteRoute._addFileChildren(
  ItServiceRouteRouteChildren,
)

interface TenantAdminRouteRouteChildren {
  TenantAdminAccessControlRoute: typeof TenantAdminAccessControlRoute
  TenantAdminAuthenticationRoute: typeof TenantAdminAuthenticationRoute
  TenantAdminIdentityRoute: typeof TenantAdminIdentityRoute
  TenantAdminIntegrationsRoute: typeof TenantAdminIntegrationsRoute
  TenantAdminMcpRoute: typeof TenantAdminMcpRoute
  TenantAdminMenuManagementRoute: typeof TenantAdminMenuManagementRoute
  TenantAdminMonitoringRoute: typeof TenantAdminMonitoringRoute
  TenantAdminOrganizationRoute: typeof TenantAdminOrganizationRoute
  TenantAdminOverviewRoute: typeof TenantAdminOverviewRoute
  TenantAdminIndexRoute: typeof TenantAdminIndexRoute
}

const TenantAdminRouteRouteChildren: TenantAdminRouteRouteChildren = {
  TenantAdminAccessControlRoute: TenantAdminAccessControlRoute,
  TenantAdminAuthenticationRoute: TenantAdminAuthenticationRoute,
  TenantAdminIdentityRoute: TenantAdminIdentityRoute,
  TenantAdminIntegrationsRoute: TenantAdminIntegrationsRoute,
  TenantAdminMcpRoute: TenantAdminMcpRoute,
  TenantAdminMenuManagementRoute: TenantAdminMenuManagementRoute,
  TenantAdminMonitoringRoute: TenantAdminMonitoringRoute,
  TenantAdminOrganizationRoute: TenantAdminOrganizationRoute,
  TenantAdminOverviewRoute: TenantAdminOverviewRoute,
  TenantAdminIndexRoute: TenantAdminIndexRoute,
}

const TenantAdminRouteRouteWithChildren =
  TenantAdminRouteRoute._addFileChildren(TenantAdminRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  EntryRouteRoute: EntryRouteRoute,
  ItServiceRouteRoute: ItServiceRouteRouteWithChildren,
  TenantAdminRouteRoute: TenantAdminRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  WorkflowSettingsRoute: WorkflowSettingsRoute,
  McpOauthCallbackRoute: McpOauthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
